(function() {
    'use strict';

    angular
        .module('app.layout')
        .controller('ShellController', ShellController);

    /* @ngInject */
    function ShellController($timeout, config, logger, translateFilter) {
        var vm = this;
        vm.busyMessage = translateFilter('ADVISOR_PLEASE_WAIT');
        vm.isBusy = true;
        vm.showSplash = true;
        vm.footerData = {};
        vm.setFooter = setFooter;


        activate();

        function activate() {
            // logger.success( translateFilter('ADVISOR_LOADED') , null);
            hideSplash();
        }



        function setFooter(data){
            vm.footer = data;
        }
        function hideSplash() {
            //Force a 1 second delay so we can see the splash.
            $timeout(function() {
                vm.showSplash = false;
            }, 1000);
        }
    }
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/layout/shell.controller.js
 ** module id = 221
 ** module chunks = 0
 **/